import { gql } from '@apollo/client'

export const GET_ADD_ISSUE_ARTICLE = gql`
    query AddIssueArticle($containerGuid: String!) {
        site {
            guid
            maxCharactersInAbstract
        }
        viewer {
            guid
            canInsertMedia(subtype: "blog")
        }
        entity(guid: $containerGuid) {
            guid
            ... on MagazineIssue {
                url
                canEdit
            }
        }
    }
`
